<template>
  <div class="row bg-white accesory-box">
    <div class="col form-group d-flex align-items-center mb-2">
      <span class="w-100">
        <h3 class="h5 mt-3 fw-bold">{{ name }}</h3>
        <span
          v-if="selectable"
          class="info me-2"
          :id="`${aKey}-tooltip`"
          data-toggle="tooltip"
          data-placement="right"
          >?</span
        >
        <small>
          <span v-if="typeof insurancePrice == 'string'">{{ insurancePrice }}</span>
          <span v-else-if="insurancePrice === -1">Nem nyújtunk rá fedezetet</span>
          <span v-else-if="typeof insurancePrice == 'number' && insurancePrice"
            >biztosítási összeg: {{ insurancePrice | currency }}</span
          >
          <span v-if="customEnding">{{ customEnding }}</span>
        </small>
      </span>
    </div>
    <div class="col-sm-3 d-flex align-items-center" v-if="insuranceFee">
      <span v-if="typeof insuranceFee == 'number'">
        <b>+{{ insuranceFee | currency }}</b> /év
      </span>
      <span v-else v-html="insuranceFee"> </span>
    </div>
    <div
      class="col-sm-3 d-flex align-items-center justify-content-sm-end my-3"
      v-if="insurancePrice !== -1 && selectable"
    >
      <div class="form-check">
        <input
          type="checkbox"
          class="form-check-input"
          :id="aKey"
          :name="`${aKey}[]`"
          :value="1"
          v-model="selected"
          @click="clickOn($event)"
        />
        <label :for="aKey" class="form-check-label">Kérem</label>
      </div>
    </div>
    <div
      class="col-12 mb-2"
      v-if="
        [
          'ertektargy',
          'baleset',
          'utasbiztositas',
          'kegyeleti',
          'felelosseg',
          'mezogazdasag',
          'kiemeltingosag',
        ].includes(aKey) && selected
      "
    >
      <div v-if="aKey == 'ertektargy'">
        <ValidationProvider :immediate="true" rules="valuables_above_200_max" v-slot="{errors}">
          <input type="text" :value="valuesAbove200Sum" disabled hidden />
          <div class="text-danger mb-3">{{ errors[0] }}</div>
        </ValidationProvider>
        <div class="form-group row mb-3">
          <label class="col-sm-4" for="nemesfemek">Nemesfémek, ékszerek, drágakövek</label>
          <ValidationProvider
            rules="required|currency_min:0"
            v-slot="{errors, classes}"
            class="col-sm-8"
            v-if="selectable"
          >
            <div class="input-group">
              <input
                v-currency="{valueRange: {min: 0}}"
                class="form-control"
                id="nemesfemek"
                name="ekszerek"
                aria-describedby="nemesfemek-prepend"
                :class="classes"
                v-model="jewelryPrice"
              />
              <div class="input-group-append d-block">
                <span class="input-group-text" id="nemesfemek-prepend">Ft</span>
              </div>
            </div>
            <small id="nemesfemek-error" class="text-danger input-alert">{{ errors[0] }}</small>
          </ValidationProvider>
          <div class="col-sm-8" v-else>{{ jewelryPrice | currency }}</div>
        </div>
        <div class="form-group row mb-3">
          <label class="col-sm-4" for="gyujtemeny">Katalogizált érme- és bélyeggyűjtemény</label>
          <ValidationProvider
            rules="required|currency_min:0"
            v-slot="{errors, classes}"
            class="col-sm-8"
            v-if="selectable"
          >
            <div class="input-group">
              <input
                v-currency="{valueRange: {min: 0}}"
                class="form-control"
                id="gyujtemeny"
                name="gyujtemeny"
                aria-describedby="gyujtemeny-prepend"
                :class="classes"
                v-model="collectionPrice"
              />
              <div class="input-group-append d-block">
                <span class="input-group-text" id="gyujtemeny-prepend">Ft</span>
              </div>
            </div>
            <small id="gyujtemeny-error" class="text-danger input-alert">{{ errors[0] }}</small>
          </ValidationProvider>
          <div class="col-sm-8" v-else>{{ collectionPrice | currency }}</div>
        </div>
        <div class="form-group row mb-3">
          <label class="col-sm-4" for="kepzomuveszeti"
            >Képzőművészeti és iparművészeti alkotás</label
          >
          <ValidationProvider
            rules="required|currency_min:0"
            v-slot="{errors, classes}"
            class="col-sm-8"
            v-if="selectable"
          >
            <div class="input-group">
              <input
                v-currency="{valueRange: {min: 0}}"
                class="form-control"
                id="kepzomuveszeti"
                name="kepzomuveszeti"
                aria-describedby="kepzomuveszeti-prepend"
                :class="classes"
                v-model="fineartPrice"
              />
              <div class="input-group-append d-block">
                <span class="input-group-text" id="kepzomuveszeti-prepend">Ft</span>
              </div>
            </div>
            <small id="kepzomuveszeti-error" class="text-danger input-alert">{{ errors[0] }}</small>
          </ValidationProvider>
          <div class="col-sm-8" v-else>{{ fineartPrice | currency }}</div>
        </div>
        <div class="form-group row mb-3">
          <label class="col-sm-4" for="kulonleges_textiliak"
            >Valódi szőrmék, kézi csomózású/szövésű szőnyeg</label
          >
          <ValidationProvider
            rules="required|currency_min:0"
            v-slot="{errors, classes}"
            class="col-sm-8"
            v-if="selectable"
          >
            <div class="input-group">
              <input
                v-currency="{valueRange: {min: 0}}"
                class="form-control"
                id="kulonleges_textiliak"
                name="szormek"
                aria-describedby="kulonleges_textiliak-prepend"
                :class="classes"
                v-model="exoticTextilePrice"
              />
              <div class="input-group-append d-block">
                <span class="input-group-text" id="kulonleges_textiliak-prepend">Ft</span>
              </div>
            </div>
            <small id="kulonleges_textiliak-error" class="text-danger input-alert">{{
              errors[0]
            }}</small>
          </ValidationProvider>
          <div class="col-sm-8" v-else>{{ exoticTextilePrice | currency }}</div>
        </div>
        <div class="form-group row">
          <label class="col-sm-4" for="antiktargyak">Antik tárgyak és különleges régiségek</label>
          <ValidationProvider
            rules="required|currency_min:0"
            v-slot="{errors, classes}"
            class="col-sm-8"
            v-if="selectable"
          >
            <div class="input-group">
              <input
                v-currency="{valueRange: {min: 0}}"
                class="form-control"
                id="antiktargyak"
                name="antik_butorok"
                aria-describedby="antiktargyak-prepend"
                :class="classes"
                v-model="antiquesPrice"
              />
              <div class="input-group-append d-block">
                <span class="input-group-text" id="antiktargyak-prepend">Ft</span>
              </div>
            </div>
            <small id="antiktargyak-error" class="text-danger input-alert">{{ errors[0] }}</small>
          </ValidationProvider>
          <div class="col-sm-8" v-else>{{ antiquesPrice | currency }}</div>
        </div>
      </div>
      <div v-else-if="aKey == 'baleset'">
        <div class="form-group row">
          <label class="col-sm-4">Típusa</label>
          <div class="col-sm-8" v-if="selectable">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="balesetbiztositas_tipusa"
                id="baleset_bizt_standard"
                :value="'standard'"
                v-model="accidentInsuranceType"
              />
              <label class="form-check-label" for="baleset_bizt_standard">
                Standard (5 000 Ft)
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="balesetbiztositas_tipusa"
                id="baleset_bizt_medium"
                :value="'medium'"
                v-model="accidentInsuranceType"
              />
              <label class="form-check-label" for="baleset_bizt_medium">
                Médium (10 000 Ft)
              </label>
            </div>
            <small id="balesetbiztositas_tipusa-error" class="text-danger input-alert"></small>
          </div>
          <div class="col-sm-8" v-else>
            <span v-if="accidentInsuranceType === 'standard'">Standard (5 000 Ft)</span>
            <span v-else>Médium (10 000 Ft)</span>
          </div>
        </div>
      </div>
      <div v-else-if="aKey == 'utasbiztositas'">
        <div
          class="form-group row"
          v-if="selectable"
          :class="{'mb-5': insuredPersonsTravel.length > 0}"
        >
          <label class="col-sm-4" for="utasbiztositottak_szama">
            Utasbiztosítottak száma<br /><br />
            Ha 2 fő részére szeretne utasbiztosítást kötni kérjük, 2 főt adjon hozzá abban az
            esetben is, ha az egyik biztosított adatai megegyeznek a az Ön (Szerződő) adataival.<br /><br />
            <span class="text-danger fw-normal"
              >Biztosított olyan természetes személy lehet, aki a jelen kiegészítő biztosításra
              vonatkozó írásbeli ajánlattétel napján nem töltötte be a 70. életévét</span
            >
          </label>
          <div class="col-sm-4 col-md-6 mb-4">
            <input
              class="form-control"
              type="number"
              readonly
              :value="insuredPersonsTravel.length"
              id="utasbiztositottak_szama"
              name="utasbiztositottak_szama"
            />
          </div>
          <div class="col-sm-4 col-md-2">
            <div
              class="btn btn-outline-danger w-100"
              @click="addInsuredPerson(insuredPersonsTravel, 'travelInsuranced')"
            >
              Hozzáadás
            </div>
          </div>
        </div>
        <div v-for="(person, key) in insuredPersonsTravel" :key="key">
          <h2 v-if="insuredPersonsTravel.length > 1" class="mt-5">
            {{ key + 1 }}. utasbiztosított adatai
          </h2>
          <InsuredPerson
            :person="person"
            :pKey="key"
            :selectable="selectable"
            listName="travelInsuranced"
          />
        </div>
      </div>
      <div v-else-if="aKey == 'kegyeleti'">
        <span class="text-danger fw-normal"
          >Biztosított olyan természetes személy lehet, aki a jelen kiegészítő biztosításra
          vonatkozó írásbeli ajánlattétel napján nem töltötte be a 65. életévét<br /><br
        /></span>

        <div class="form-group row">
          <label class="col-sm-4">Limitek</label>
          <div class="col-sm-8" v-if="selectable">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="kegyeleti_tipusa"
                id="kegyeleti_150"
                :value="150000"
                v-model="funeralPrice"
              />
              <label class="form-check-label" for="kegyeleti_150">
                150 000 Ft (Díj 3 000 Ft)
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="kegyeleti_tipusa"
                id="kegyeleti_300"
                :value="300000"
                v-model="funeralPrice"
              />
              <label class="form-check-label" for="kegyeleti_300">
                300 000 Ft (Díj 6 000 Ft)
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="kegyeleti_tipusa"
                id="kegyeleti_500"
                :value="500000"
                v-model="funeralPrice"
              />
              <label class="form-check-label" for="kegyeleti_500">
                500 000 Ft (Díj 10 000 Ft)
              </label>
            </div>
            <small id="kegyeleti-error" class="text-danger input-alert"></small>
          </div>
          <div class="col-sm-8" v-else>
            <span v-if="funeralPrice === 150000">150 000 Ft (Díj 3 000 Ft)</span>
            <span v-else-if="funeralPrice === 300000">300 000 Ft (Díj 6 000 Ft)</span>
            <span v-else-if="funeralPrice === 500000">500 000 Ft (Díj 10 000 Ft)</span>
          </div>
        </div>
        <div
          class="form-group row"
          v-if="selectable"
          :class="{'mb-5': insuredPersonsBurial.length > 0}"
        >
          <div class="col-sm-4 col-md-6 mb-4">
            <input
              class="form-control"
              type="number"
              readonly
              :value="insuredPersonsBurial.length"
              id="temetesbiztositottak_szama"
              name="temetesbiztositottak_szama"
            />
          </div>
          <div class="col-sm-4 col-md-2">
            <div
              class="btn btn-outline-danger w-100"
              @click="addInsuredPerson(insuredPersonsBurial, 'burialInsuranced')"
            >
              Hozzáadás
            </div>
          </div>
          <div v-for="(person, key) in insuredPersonsBurial" :key="key">
            <h2 v-if="insuredPersonsBurial.length > 1" class="mt-5">
              {{ key + 1 }}. Biztosított adatai
            </h2>
            <InsuredPerson
              :person="person"
              :pKey="key"
              :selectable="selectable"
              listName="burialInsuranced"
            />
          </div>
        </div>
      </div>
      <div v-else-if="aKey == 'felelosseg'">
        <div class="form-group row">
          <label class="col-sm-4">Típusa</label>
          <div class="col-sm-8" v-if="selectable">
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                name="altalanos_felelosseg[]"
                id="altalanos_felelosseg"
                :value="1"
                checked="true"
                @click="
                  (e) => {
                    e.preventDefault();
                  }
                "
              />
              <label class="form-check-label" for="altalanos_felelosseg">
                Általános felelősség (5 400 Ft)
              </label>
            </div>
            <div class="form-check" v-if="generalLiability">
              <input
                class="form-check-input"
                type="checkbox"
                name="berloi_felelosseg[]"
                id="berloi_felelosseg"
                :value="1"
                v-model="landlordLiability"
              />
              <label class="form-check-label" for="berloi_felelosseg">
                Bérlői felelősség (10 000 Ft)
              </label>
            </div>
          </div>
          <div class="col-sm-8" v-else>
            <span v-if="generalLiability">Általános</span>
            <span v-if="landlordLiability">Bérlői</span>
          </div>
        </div>
      </div>
      <div v-if="aKey == 'mezogazdasag'">
        <div class="form-group row mb-3">
          <label class="col-sm-4" for="termes_termeny">Termés, termény, készlet</label>
          <ValidationProvider
            rules="required|currency_min:0|currency_max:1000000"
            v-slot="{errors, classes}"
            class="col-sm-8"
            v-if="selectable"
          >
            <div class="input-group">
              <input
                v-currency="{valueRange: {min: 0, max: 1000000}}"
                class="form-control"
                id="termes_termeny"
                name="termes_termeny"
                aria-describedby="termes_termeny-prepend"
                :class="classes"
                v-model="farmingStock"
              />
              <div class="input-group-append d-block">
                <span class="input-group-text" id="termes_termeny-prepend">Ft</span>
              </div>
            </div>
            <small id="termes_termeny-error" class="text-danger input-alert">{{ errors[0] }}</small>
          </ValidationProvider>
          <div class="col-sm-8" v-else>{{ farmingStock | currency }}</div>
        </div>
        <div class="form-group row mb-3">
          <label class="col-sm-4" for="allatallomany">Állatállomány</label>
          <ValidationProvider
            rules="required|currency_min:0|currency_max:1000000"
            v-slot="{errors, classes}"
            class="col-sm-8"
            v-if="selectable"
          >
            <div class="input-group">
              <input
                v-currency="{valueRange: {min: 0, max: 1000000}}"
                class="form-control"
                id="allatallomany"
                name="allatallomany"
                aria-describedby="allatallomany-prepend"
                :class="classes"
                v-model="farmingAnimals"
              />
              <div class="input-group-append d-block">
                <span class="input-group-text" id="allatallomany-prepend">Ft</span>
              </div>
            </div>
            <small id="allatallomany-error" class="text-danger input-alert">{{ errors[0] }}</small>
          </ValidationProvider>
          <div class="col-sm-8" v-else>{{ farmingAnimals | currency }}</div>
        </div>
        <div class="form-group row">
          <label class="col-sm-4" for="gepek_felszereles">Gépek, felszerelések</label>
          <ValidationProvider
            rules="required|currency_min:0|currency_max:1000000"
            v-slot="{errors, classes}"
            class="col-sm-8"
            v-if="selectable"
          >
            <div class="input-group">
              <input
                v-currency="{valueRange: {min: 0, max: 1000000}}"
                class="form-control"
                id="gepek_felszereles"
                name="gepek_felszereles"
                aria-describedby="gepek_felszereles-prepend"
                :class="classes"
                v-model="farmingTools"
              />
              <div class="input-group-append d-block">
                <span class="input-group-text" id="gepek_felszereles-prepend">Ft</span>
              </div>
            </div>
            <small id="gepek_felszereles-error" class="text-danger input-alert">{{
              errors[0]
            }}</small>
          </ValidationProvider>
          <div class="col-sm-8" v-else>{{ farmingTools | currency }}</div>
        </div>
      </div>
      <div v-if="aKey == 'kiemeltingosag'">
        <div class="form-group row mb-3">
          <label class="col-sm-4" for="kiemeltingosag_osszeg">Érték</label>
          <ValidationProvider
            rules="required|currency_min:0|currency_max:30000000"
            v-slot="{errors, classes}"
            class="col-sm-8"
            v-if="selectable"
          >
            <div class="input-group">
              <input
                v-currency="{valueRange: {min: 0, max: 30000000}}"
                class="form-control"
                id="kiemeltingosag_osszeg"
                name="kiemeltingosag_osszeg"
                aria-describedby="kiemeltingosag_osszeg-prepend"
                :class="classes"
                v-model="priorityProperty"
              />
              <div class="input-group-append d-block">
                <span class="input-group-text" id="kiemeltingosag_osszeg-prepend">Ft</span>
              </div>
            </div>
            <small id="kiemeltingosag_osszeg-error" class="text-danger input-alert">{{
              errors[0]
            }}</small>
          </ValidationProvider>
          <div class="col-sm-8" v-else>{{ priorityProperty | currency }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import {parse} from 'vue-currency-input';
import {mapFields} from 'vuex-map-fields';
import InsuredPerson from './InsuredPerson';

export default {
  props: ['accesory', 'aKey', 'selectable'],
  components: {InsuredPerson},
  computed: {
    selected: {
      get() {
        return this.$store.state.chooseableAccesories.selectableList[this.aKey].selected;
      },
      set(value) {
        this.$store.commit('updateAccesory', {key: this.aKey, value: value});
      },
    },
    name: {
      get() {
        return this.$store.state.chooseableAccesories.selectableList[this.aKey].name;
      },
    },
    insurancePrice: {
      get() {
        return this.$store.state.chooseableAccesories.selectableList[this.aKey].insurancePrice;
      },
    },
    insuranceFee: {
      get() {
        return this.$store.state.chooseableAccesories.selectableList[this.aKey].insuranceFee;
      },
    },
    customEnding: {
      get() {
        return this.$store.state.chooseableAccesories.selectableList[this.aKey].customEnding;
      },
    },
    ...mapFields([
      'generalInfo.propertyInhabitated',
      'chooseableAccesories.valuablesAbove200',
      'chooseableAccesories.valuablesAboveInputs',
      'chooseableAccesories.valuesAbove200Sum',
      'chooseableAccesories.valuesAbove200Minimum',
      'chooseableAccesories.valuesAbove200Maximum',
      'chooseableAccesories.accidentInsuranceType',
      'chooseableAccesories.funeralPrice',
      'chooseableAccesories.generalLiability',
      'chooseableAccesories.landlordLiability',
      'chooseableAccesories.farmingStock',
      'chooseableAccesories.farmingAnimals',
      'chooseableAccesories.farmingTools',
      'chooseableAccesories.priorityProperty',
    ]),
    ...mapFields({
      jewelryPrice: 'chooseableAccesories.valuablesAboveInputs.jewelry',
      antiquesPrice: 'chooseableAccesories.valuablesAboveInputs.antiques',
      exoticTextilePrice: 'chooseableAccesories.valuablesAboveInputs.exotic',
      collectionPrice: 'chooseableAccesories.valuablesAboveInputs.collection',
      fineartPrice: 'chooseableAccesories.valuablesAboveInputs.fineart',
      accesoriesList: 'chooseableAccesories.selectableList',
      insuredPersonTemplate: 'chooseableAccesories.personTemplate',
      insuredPersonsTravel: 'chooseableAccesories.travelInsuranced.list',
      insuredPersonsBurial: 'chooseableAccesories.burialInsuranced.list',
    }),
  },
  watch: {
    valuablesAboveInputs: {
      deep: true,

      handler(data) {
        this.calculateSumPrice(data);
      },
    },
    selected: function(value) {
      if (!value) {
        if (this.aKey === 'kiemeltingosag') {
          this.$store.commit('setChooseableAccesories', {
            name: 'priorityProperty',
            value: 0,
          });
        }
        if (this.aKey === 'felelosseg') {
          this.$store.commit('setChooseableAccesories', {
            name: 'landlordLiability',
            value: false,
          });
        }
        if (this.aKey === 'mezogazdasag') {
          this.$store.commit('setChooseableAccesories', {
            name: 'farmingStock',
            value: 0,
          });
          this.$store.commit('setChooseableAccesories', {
            name: 'farmingAnimals',
            value: 0,
          });
          this.$store.commit('setChooseableAccesories', {
            name: 'farmingTools',
            value: 0,
          });
        }
      }
    },
  },
  methods: {
    clickOn(e) {
      if (e && this.selected) e.preventDefault();
      if (this.selected) {
        Swal.fire({
          title: 'Biztos, hogy el akarja távolítani?',
          text:
            'Gondolja meg, mert egy esetleges kár esetén valóban hasznos kiegészítő lehet ez a biztosítási fedezet.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Igen, eltávolítom',
          cancelButtonText: 'Megtartom',
          confirmButtonColor: '#E4002C',
        }).then((result) => {
          if (result.value) this.selected = false;
        });
      }
    },
    calculateSumPrice(data) {
      let price = 0;
      for (const [key, value] of Object.entries(data)) {
        if (typeof value == 'string') {
          const parsedInt = parse(value, window.currencyInputOptions);
          if (parsedInt) price += parsedInt;
        }
      }

      this.valuesAbove200Sum = price;
    },
    addInsuredPerson(insuredPersons, listName) {
      if (insuredPersons.length < 10)
        this.$store.commit('addInsuredPerson', {
          listName: listName,
          person: Object.assign({}, this.insuredPersonTemplate),
        });
    },
  },
};
</script>

<style lang="scss">
.accesory-box {
  border-radius: 0.25rem;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;

  h3 {
    word-break: normal;
    word-wrap: break-word;
    white-space: pre-wrap;
  }
}
</style>
